import React, { FC } from 'react';

import { usePaymentContext } from 'features/payment';
import noop from 'lodash-es/noop';
import { useIntl } from 'react-intl';

import ActionButton, { ActionButtonVariants } from 'components/action-button';
import { logAddPaymentMethodClick } from 'state/amplitude';
import { routes } from 'utils/routing';

export const AddGiftCardLink: FC<React.PropsWithChildren<{
  setIsAddGiftCardVisible?: (param: boolean) => void;
  setIsTransferGiftCardVisible?: (param: boolean) => void;
}>> = ({ setIsAddGiftCardVisible = noop, setIsTransferGiftCardVisible = noop }) => {
  const { formatMessage } = useIntl();
  const { getPrepaidPaymentMethod } = usePaymentContext();
  const hasGiftCard = !!getPrepaidPaymentMethod();

  const buttonText = hasGiftCard
    ? formatMessage(
        { id: 'transferBalanceFromPrepaidCard' },
        { cardAlias: formatMessage({ id: 'cardAlias.bk' }) }
      )
    : formatMessage({
        id: 'addNewPaymentMethodGiftCard',
      });

  const setGiftCardModalVisible = hasGiftCard
    ? setIsTransferGiftCardVisible
    : setIsAddGiftCardVisible;
  if (setGiftCardModalVisible !== noop) {
    return (
      <ActionButton
        fullWidth
        variant={ActionButtonVariants.OUTLINE}
        onPress={() => {
          setGiftCardModalVisible(true);
          logAddPaymentMethodClick();
        }}
        testID={hasGiftCard ? 'transfer-gift-card' : 'add-new-gift-card'}
      >
        {buttonText}
      </ActionButton>
    );
  }

  return (
    <ActionButton
      fullWidth
      variant={ActionButtonVariants.OUTLINE}
      to={hasGiftCard ? routes.transferGiftCard : routes.addGiftCard}
      onPress={logAddPaymentMethodClick}
      testID={hasGiftCard ? 'transfer-gift-card' : 'add-new-gift-card'}
    >
      {buttonText}
    </ActionButton>
  );
};
